import { Box } from '@/components/Box/Box';
import { Typography } from '@/components/Typography/Typography';
import { FormikSwitchToggle } from '@/components/form/fields/FormikSwitchToggle/FormikSwitchToggle';
import { ReactNode } from 'react';
import { COLORS } from '@/styles/colors';

type CookiesPreferencesSectionType = {
  label: ReactNode;
  name: string;
  children: ReactNode;
  disabled?: boolean;
};

export const CookiesPreferencesSection = ({ label, name, disabled, children }: CookiesPreferencesSectionType) => {
  return (
    <Box display='flex' flexDirection='column' rowGap='18px'>
      <FormikSwitchToggle
        name={name}
        disabled={disabled}
        hasErrorComponent={false}
        label={
          <Typography variant='headline5' fontWeight='semibold' color={COLORS.grey[900]}>
            {label}
          </Typography>
        }
      />
      <Typography color={COLORS.grey[850]}>{children}</Typography>
    </Box>
  );
};
